import {useState} from "react";

import PageHeading from "../../shared/containers/PageHeading";

import DashboardSearch from "../../modules/Dashboard/DashboardSearch";
import DashboardCharts from "../../modules/Dashboard/DashboardCharts";

const DashboardPage = () => {
    const [dateRange, setDateRange] = useState(null);
    const changeDateRange = (value) => {
        setDateRange([value[0], value[1]])
    }
    return (
        <>
            <PageHeading title="Dashboard" subtitle="Life Update Information">
                <DashboardSearch onChange={changeDateRange}/>
            </PageHeading>
            <DashboardCharts dateRange={dateRange} />
        </>
    )
}

export default DashboardPage;
